import { Segment, Subjects } from '../const';
import { ClaimType, NavigationState } from '../store/navigation.type';

// The mapping of category (currently only Claims) to Subject
// which eventually maps to Genesys destination code in register-callback-api.
const SUBJECT_MAPPING: Readonly<{ [key in ClaimType]: keyof typeof Subjects }> = {
  CLAIMS_CONTENT: 'CLAIMS_CONTENT',
  CLAIMS_AUTO: 'CLAIMS_AUTO',
  CLAIMS_BUILDING: 'CLAIMS_BUILDING',
  CLAIMS_PERSONAL: 'CLAIMS_PERSONAL',
  CLAIMS_ANIMAL: 'CLAIMS_ANIMAL',
  CLAIMS_TRAVEL: 'CLAIMS_TRAVEL',
  CLAIMS_OTHER: 'CLAIMS_OTHER',
} as const;

export default function getDestinationCode(navigationState: NavigationState): { flow: string; subject: string } {
  const {
    bookingOption,
    area,
    category,
    selections: {
      insurance: { category: insurance },
      injury: { category: claim },
    },
  } = navigationState;

  if (!area) {
    throw new Error('Area must not be empty');
  }

  if (!category) {
    throw new Error('Category must not be empty');
  }

  let flow: Segment;
  if (area === 'commercial') {
    flow = Segment.PROFESSIONAL;
  } else if (area === 'agriculture') {
    flow = Segment.AGRICULTURE;
  } else {
    if (category === 'injury') {
      flow = Segment.CLAIMS;
    } else if ((category === 'insurance' || category === 'others') && bookingOption === 'soonest') {
      flow = Segment.ASAP;
    } else {
      flow = Segment.COMMON;
    }
  }

  let subject: Subjects;
  switch (area) {
    case 'private':
      switch (category) {
        case 'insurance':
        case 'others':
          subject = Subjects.PHONE;
          break;
        case 'injury':
          subject = Subjects[getSubjectFromClaimType(claim ?? 'CLAIMS_OTHER')];
          break;
      }
      break;
    case 'commercial':
      switch (category) {
        case 'insurance':
          // An exception for Erhverv > Forsikringer > Tilbud
          if (insurance === 'offer') {
            subject = Subjects.SALGSCENTER;
          } else {
            subject = Subjects.SERVICETJEK;
          }
          break;
        case 'others':
          subject = Subjects.SERVICETJEK;
          break;
        case 'injury':
          subject = Subjects.SKADER;
          break;
      }
      break;
    case 'agriculture':
      switch (category) {
        case 'insurance':
        case 'others':
          subject = Subjects.KUNDESERVICE;
          break;
        case 'injury':
          subject = Subjects.SKADER;
          break;
      }
      break;
  }

  return {
    flow,
    subject,
  };
}

function getSubjectFromClaimType(claimType: ClaimType): keyof typeof Subjects {
  return SUBJECT_MAPPING[claimType];
}
